// extracted by mini-css-extract-plugin
export default {"section_toggle":"SectionToggle-module_section_toggle__BALAW"};